import InputTextArea from "./inputTextArea";

export default InputTextArea;